import { useMemo } from "react"

import { ContentTag } from "scrivito"
import { ProductObjClass } from "scrivito/Objs/Product/ProductObjClass"

import { FollowUpConfigurationProduct } from "entities/dim-configuration/types/FollowUpConfiguration"
import { getProductType } from "entities/products/lib/getProductType"
import { ProductSelectOption } from "entities/products/types/ProductSelectOption"

export function useFollowUpConfigurationProductOptions(
  products: FollowUpConfigurationProduct[]
): ProductSelectOption[] {
  const productTypes = products.map(product =>
    getProductType(product.productName)
  )
  const productObjs = productTypes.length
    ? ProductObjClass.where("productType", "equals", productTypes).toArray()
    : []
  const productObjIDs = productObjs.map(productObj => productObj.id()).join()

  return useMemo(() => {
    const productObjsByType = new Map(
      productObjs.map(productObj => [productObj.get("productType"), productObj])
    )

    return products.map(product => {
      const productObj = productObjsByType.get(
        getProductType(product.productName)
      )

      return {
        value: product.productName,
        label: product.productName,
        data: productObj,
        image: productObj ? (
          <ContentTag alt="" content={productObj} attribute="imageWidgets" />
        ) : undefined
      }
    })
    // Scrivito returns a new array on every render, so the resolved IDs are the
    // stable dependency.
  }, [products, productObjIDs])
}
